import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductWithAFrameData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import { useCmsData } from '../../../../../context/CmsContext.js';
import '../../../../../types/product.js';
import { getActiveBrandPromotion } from '../../../../../utils/get-active-brand-promotion.js';
import { TryOnButton } from '../../../components/TryOnButton/TryOnButton.js';
import { useVto } from '../../../context/VtoProvider.js';
import { vtoEvent } from '../../../utils/vto-event.js';
import { mapGraphVariantsToVirtualMirror } from '../../mappers/mapGraphVariantsToVirtualMirror.js';
import { VirtualMirrorModal } from '../VirtualMirrorModal/VirtualMirrorModal.js';

const VirtualMirrorContainer = ({ className , onToggleWishlist , wishlistedSkuItems ,  })=>{
    var ref;
    const { isVtoTransitionsEnabled  } = useFeatureToggles();
    const { activeVariant: { sku , isVtoEnabled  } , product ,  } = useProductWithAFrameData();
    const { isVtoActive , isVtoFeatureEnabled  } = useVto();
    const { brandPromotions  } = useCmsData();
    const { brandName , variants  } = product;
    const isVirtualMirrorEnabled = isVtoEnabled && isVtoFeatureEnabled;
    React.useEffect(()=>{
        if (sku && isVirtualMirrorEnabled) {
            vtoEvent('vto.view', {
                sku
            });
        }
    }, [
        sku,
        isVirtualMirrorEnabled
    ]);
    const brandLogo = (ref = getActiveBrandPromotion(brandName, brandPromotions)) === null || ref === void 0 ? void 0 : ref.logo;
    const mappedVTOVariants = isVirtualMirrorEnabled ? mapGraphVariantsToVirtualMirror(product, variants, sku, brandLogo, isVtoTransitionsEnabled) : undefined;
    const isTransitionFeatureEnabled = isVtoTransitionsEnabled && product.isOfferedWithPrescriptions;
    const transitionFeature = isTransitionFeatureEnabled ? {
        enabled: true
    } : undefined;
    if (!isVirtualMirrorEnabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TryOnButton, {
        className: className
    }), isVtoActive && /*#__PURE__*/ React.createElement(VirtualMirrorModal, {
        variants: mappedVTOVariants,
        onToggleWishlist: onToggleWishlist,
        wishlistedSkuItems: wishlistedSkuItems,
        transitionFeature: transitionFeature
    }));
};

export { VirtualMirrorContainer };
//# sourceMappingURL=VirtualMirrorContainer.js.map
